<template>
  <RkTable :data="equityChangeData" :loading="loading" :finished="finished" @load="getHoldChangeData">
    <RkTableColumn prop="changeDate" label="变动日期" align="left" :width="`${postcssPatch(100)}`">
      <template slot-scope="{ row }">{{ $digitjs(row.changeDate).isNull() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="issuedShare" label="已发行普通股(股)">
      <template slot-scope="{ row }">{{ $digitjs(row.issuedShare).convert() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="changeReason" label="变动原因">
      <template slot-scope="{ row }">{{ $t($digitjs(row.changeReason).isNull()) }}</template>
    </RkTableColumn>
  </RkTable>
</template>

<script>
import { postcssPatch } from '@/utils/postcssPatch'

export default {
  data() {
    return {
      loading: false,
      finished: false,
      pageNum: 0,
      equityChangeData: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    }
  },
  methods: {
    postcssPatch,
    async getHoldChangeData() {
      this.loading = true
      this.pageNum++
      const res = await this.$post(this.$api.f10.hk + '/summary/hold-change', {
        type: 'S',
        pageNum: this.pageNum,
        pageSize: 20,
        symbol: this.symbol
      })
      const data = res.data ?? []
      if (data.length === 0) {
        this.finished = true
        return
      }
      this.equityChangeData = [...this.equityChangeData, ...data]
      this.loading = false
    }
  }
}
</script>
